export const findMarketFromOptions = (marketId, marketsOptions) =>
	marketsOptions.find((market) => market.value === marketId);
